import { render, staticRenderFns } from "./ListadoProgramas.vue?vue&type=template&id=37a01bd7"
import script from "./ListadoProgramas.vue?vue&type=script&lang=js"
export * from "./ListadoProgramas.vue?vue&type=script&lang=js"
import style0 from "./ListadoProgramas.vue?vue&type=style&index=0&id=37a01bd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports